import { Rocket } from 'lucide-react';
import { Modal } from '../../elements/Modal';
import { useNavigate } from 'react-router-dom';

interface LaunchConfirmedModalProps {
  open: boolean;
  onClose: () => void;
  campaignName: string;
}

export default function LaunchConfirmedModal({
  open,
  onClose,
  campaignName,
}: LaunchConfirmedModalProps) {
  const navigate = useNavigate();

  const handleGoToDashboard = () => {
    onClose();
    navigate('/dashboard');
  };

  return (
    <Modal open={open} onClose={onClose}>
      <div className="p-8 text-center">
        <div className="flex justify-center mb-6">
          <div className="relative w-20 h-20 flex items-center justify-center">
            <div className="absolute inset-0 bg-green-500/20 rounded-full animate-ping" />
            <div className="relative w-16 h-16 rounded-full border-2 border-accent flex items-center justify-center bg-brand-surface">
              <Rocket className="w-8 h-8 text-accent" />
            </div>
          </div>
        </div>

        <h2 className="text-2xl font-bold text-neutral-light mb-4">Launch Confirmed!</h2>

        <p className="text-text-muted mb-8">
          Your campaign <span className="font-semibold text-neutral-light">{campaignName}</span> is
          now live. Tracking pixels are active and bids have been placed in the market.
        </p>

        <button
          onClick={handleGoToDashboard}
          className="w-full px-6 py-3 bg-primary-500 hover:bg-primary-600 text-black font-medium rounded-lg transition-colors"
        >
          Go to Dashboard
        </button>
      </div>
    </Modal>
  );
}
